import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const PATIENT_TOKEN_KEY = 'patient_portal_token';
const PATIENT_PHONE_KEY = 'patient_portal_phone';

const patientApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

patientApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(PATIENT_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

patientApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && sessionStorage.getItem(PATIENT_TOKEN_KEY)) {
      sessionStorage.removeItem(PATIENT_TOKEN_KEY);
      sessionStorage.removeItem(PATIENT_PHONE_KEY);
      if (!window.location.pathname.startsWith('/patient-portal')) return Promise.reject(error);
      window.location.href = '/patient-portal';
    }
    return Promise.reject(error);
  }
);

export const setPatientSession = (token, phone) => {
  sessionStorage.setItem(PATIENT_TOKEN_KEY, token);
  sessionStorage.setItem(PATIENT_PHONE_KEY, phone);
};

export const clearPatientSession = () => {
  sessionStorage.removeItem(PATIENT_TOKEN_KEY);
  sessionStorage.removeItem(PATIENT_PHONE_KEY);
};

export const getPatientPhone = () => sessionStorage.getItem(PATIENT_PHONE_KEY);
export const isPatientAuthed = () => Boolean(sessionStorage.getItem(PATIENT_TOKEN_KEY));

export default patientApi;
